var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDocumentText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M25.625 12.7375H22.0125C19.05 12.7375 16.6375 10.325 16.6375 7.3625V3.75C16.6375 3.0625 16.075 2.5 15.3875 2.5H10.0875C6.2375 2.5 3.125 5 3.125 9.4625V20.5375C3.125 25 6.2375 27.5 10.0875 27.5H19.9125C23.7625 27.5 26.875 25 26.875 20.5375V13.9875C26.875 13.3 26.3125 12.7375 25.625 12.7375Z",
    fill: "#006CB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7496 2.76249C19.2371 2.24999 18.3496 2.59999 18.3496 3.31249V7.67499C18.3496 9.49999 19.8996 11.0125 21.7871 11.0125C22.9746 11.025 24.6246 11.025 26.0371 11.025C26.7496 11.025 27.1246 10.1875 26.6246 9.68749C24.8246 7.87499 21.5996 4.61249 19.7496 2.76249Z",
    fill: "#006CB2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 17.1875H9.375C8.8625 17.1875 8.4375 16.7625 8.4375 16.25C8.4375 15.7375 8.8625 15.3125 9.375 15.3125H16.875C17.3875 15.3125 17.8125 15.7375 17.8125 16.25C17.8125 16.7625 17.3875 17.1875 16.875 17.1875Z",
    fill: "#006CB2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 22.1875H9.375C8.8625 22.1875 8.4375 21.7625 8.4375 21.25C8.4375 20.7375 8.8625 20.3125 9.375 20.3125H14.375C14.8875 20.3125 15.3125 20.7375 15.3125 21.25C15.3125 21.7625 14.8875 22.1875 14.375 22.1875Z",
    fill: "#006CB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocumentText);
export default __webpack_public_path__ + "static/media/ic-document-text.61d37fc3a64ee8861e973a12d8ff1a07.svg";
export { ForwardRef as ReactComponent };